export default __webpack_public_path__ + "static/media/gallery_10.efb8e5b3.jpg";